export const assignedApps = (terminal) => Array.isArray(terminal?.latestApplications)
  ? terminal.latestApplications.filter(Boolean)
  : terminal?.latestApplication ? [terminal.latestApplication] : []

// Preserve the distinction between an empty reported list and no report.
export const installedApps = (terminal) => Array.isArray(terminal?.installedApplications)
  ? terminal.installedApplications.filter(Boolean)
  : terminal && Object.prototype.hasOwnProperty.call(terminal, "installedApplications") ? null
  : terminal?.currentApplication ? [terminal.currentApplication] : null

export const appSearchText = (apps) => (apps || []).map((app) =>
  [app.appName, app.appId, app.appVersion, app.versionCode, app.downldStatus].filter((value) => value != null).join(" ")
).join(" | ")

export const appStatusLabel = (status) => status === "NEW_TMNL_APP" ? "New assignment" :
  status ? String(status).replace(/_/g, " ").toLowerCase().replace(/^./, (letter) => letter.toUpperCase()) : "Not reported"
